import { v1 as uuidv1 } from 'uuid';

export const SET_POSDAYTOTALS = `OpenCloseDay: SETPOSDAYTOTALS→${uuidv1()}`;
export const CLOSE_DAY = `OpenCloseDay: CLOSE→${uuidv1()}`;
export const OPEN_DAY = `OpenCloseDay: OPEN→${uuidv1()}`;
export const LOADING = `OpenCloseDay: LOADING→${uuidv1()}`;
